import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { Combobox, shouldSearchSelect } from './combobox.js';
import { FormField } from './form-field.js';
import { Label } from './label.js';
import { Select } from './select.js';
/**
 * Значение пункта «Все» (`allLabel`). У Radix Select нет значения «ничего не
 * выбрано» — пустая строка как значение пункта запрещена, а `undefined`
 * неотличим от «значение ещё не пришло». Вызывающий снимает маркер на границе
 * запроса: `v === SELECT_ALL_VALUE ? undefined : v`.
 */
export const SELECT_ALL_VALUE = '__all__';
/**
 * Фильтр «подпись над выпадающим списком» — строка фильтров над таблицей.
 *
 * В ките, а не в модуле: та же пара `Label` + `Select` жила копиями в списке
 * кейсов чарджбеков (`FilterSelect`), ленте комментариев (автор) и разделе
 * «Контент». Доступное имя триггер получает от `<Label htmlFor>` — отдельный
 * `aria-label` с тем же текстом был бы вторым источником имени.
 */
export function SelectField({ id, label, value, onChange, options, allLabel, placeholder, description, size, disabled, searchable, className, }) {
    const descriptionId = description ? `${id}-description` : undefined;
    const total = options.length + (allLabel !== undefined ? 1 : 0);
    if (shouldSearchSelect(total, searchable)) {
        return (_jsxs("div", { className: cn('flex min-w-[170px] flex-col gap-1', className), children: [_jsx(Label, { htmlFor: id, children: label }), _jsx(Combobox, { id: id, size: size ?? 'md', options: [
                        ...(allLabel !== undefined ? [{ value: SELECT_ALL_VALUE, label: allLabel }] : []),
                        ...options.map((o) => ({
                            value: o.value,
                            label: o.label,
                            ...(o.keywords ? { keywords: o.keywords } : {}),
                        })),
                    ], value: value === '' ? null : value, 
                    // Значения «ничего» у списка нет (как и у Select): снять выбор нельзя.
                    onChange: (next) => {
                        if (next != null)
                            onChange(next);
                    }, placeholder: placeholder ?? 'Выберите…', disabled: disabled, "aria-describedby": descriptionId }), description ? (_jsx(FormField.Description, { id: descriptionId, children: description })) : null] }));
    }
    return (_jsxs("div", { className: cn('flex min-w-[170px] flex-col gap-1', className), children: [_jsx(Label, { htmlFor: id, children: label }), _jsxs(Select, { value: value, onValueChange: onChange, ...(disabled ? { disabled } : {}), children: [_jsx(Select.Trigger, { id: id, ...(size ? { size } : {}), ...(descriptionId ? { 'aria-describedby': descriptionId } : {}), children: _jsx(Select.Value, { ...(placeholder ? { placeholder } : {}) }) }), _jsxs(Select.Content, { children: [allLabel !== undefined ? (_jsx(Select.Item, { value: SELECT_ALL_VALUE, children: allLabel })) : null, options.map((o) => (_jsx(Select.Item, { value: o.value, children: o.label }, o.value)))] })] }), description ? (_jsx(FormField.Description, { id: descriptionId, children: description })) : null] }));
}
//# sourceMappingURL=select-field.js.map